export default class NoDoubleValues {
  public get className(): string {
    return "NoDoubleValues";
  }

  doubleName(name: String, list: Array<string>): boolean {
    for (let i = 0; i < list.length; i++) {
      if (name == list[i]) {
        return true;
      }
    }
    return false;
  }

  ciEquals(a: string, b: string) {
    return typeof a === "string" && typeof b === "string"
      ? a.localeCompare(b, undefined, { sensitivity: "accent" }) === 0 // no itx
      : a === b;
  }

  getCopiedStringText(string: string): string {

    const regExp = /\(([^)]+)\)/g;
    const matches = string.match(regExp);

    if (matches != null) {
      const lastBracket = matches[matches.length - 1];
      string = string.slice(0, -lastBracket.length);
      let content = lastBracket.slice(1, -1); // Remove the outer parentheses

      // Check if content is ONLY a number (integer no date)
      const isOnlyNumber = /^\d+$/.test(content);

      if (isOnlyNumber) {
        // If it's only a number, increment it
        let number = Number(content) + 1;
        string = string + `(${number})`;
      } else {
        // If it's not only a number (date or text), append a new bracket with (1)
        string = string + lastBracket + `(1)`;
      }
    } else {
      string = string + `(1)`;
    }
    return string;
  }
}
